export default () => {
    return [
        {
            path: '/produzioneTask',
            name: 'produzioneTask',
            component: () => import('./views/produzioneTask.vue'),
        },
    ];
};
